const shoppingCart = {
    state: {
        cartAmount: 0
    },
    mutations: {
        calculationNumber(state,val) {
            state.cartAmount = val
        }
    }
}

export default shoppingCart;